export default __webpack_public_path__ + "static/media/pj-space-shooter.6d2c81ea.png";